/*
  Project: Kirche
  Author: Dawid Kotlarz
 */
window.jQuery = window.$ = require('jquery');
require('./jquery.smoove.min');
require('./lightslider');
require('./functions');